module.exports = __webpack_public_path__ + "static/Untitled-1-09-min-8dd296b6d5163d7a1ca09b406ff677c5.jpg";